import { AuthProvider } from 'contexts/AuthContext';
import { NotificaçõesProvider } from 'contexts/NotificaçõesContext';
import { GridProvider } from 'contexts/GridContext';
import { DropsProvider } from 'contexts/DropsContext';
import { RelatoriosProvider } from 'contexts/RelatoriosContext';
import { LocalProvider } from 'contexts/LocalContext';
import { EnderecoProvider } from 'contexts/EnderecoContext';
import { ExpedicoesProvider } from 'contexts/ExpedicoesContext';
import { ProdutosProvider } from 'contexts/ProdutosContext';
import { EstoqueProvider } from 'contexts/EstoqueContext';
import { ArmazenagemProvider } from 'contexts/ArmazenagemContext';
import { DashboardProvider } from 'contexts/DashboardContext';
import {
  DialogProvider,
  ModalProvider,
  DrawerProvider,
} from 'components/Modals';

const Providers = ({ children }) => (
  <AuthProvider>
    <NotificaçõesProvider>
      <GridProvider>
        <DropsProvider>
          <RelatoriosProvider>
            <LocalProvider>
              <EnderecoProvider>
                <ExpedicoesProvider>
                  <ProdutosProvider>
                    <EstoqueProvider>
                      <ArmazenagemProvider>
                        <DashboardProvider>
                          <ModalProvider>
                            <DialogProvider>
                              <DrawerProvider>{children}</DrawerProvider>
                            </DialogProvider>
                          </ModalProvider>
                        </DashboardProvider>
                      </ArmazenagemProvider>
                    </EstoqueProvider>
                  </ProdutosProvider>
                </ExpedicoesProvider>
              </EnderecoProvider>
            </LocalProvider>
          </RelatoriosProvider>
        </DropsProvider>
      </GridProvider>
    </NotificaçõesProvider>
  </AuthProvider>
);

export default Providers;
